var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    {
      staticClass: "col content-spacing",
      staticStyle: { padding: "0.5rem 0", "max-width": "88% !important" },
      attrs: { role: "main" }
    },
    [
      _c("PageHeader", { attrs: { pageTitle: "Panorama Custom" } }, [
        _c(
          "div",
          { staticStyle: { display: "flex", gap: "0.5rem" } },
          [
            _c("b-form-select", {
              staticClass: "form-control",
              staticStyle: { color: "green" },
              attrs: { options: _vm.filteredOptions("A") },
              scopedSlots: _vm._u([
                {
                  key: "first",
                  fn: function() {
                    return [
                      _c("b-form-select-option", { attrs: { value: null } }, [
                        _vm._v("Selecione a opção A")
                      ])
                    ]
                  },
                  proxy: true
                }
              ]),
              model: {
                value: _vm.customOptionA,
                callback: function($$v) {
                  _vm.customOptionA = $$v
                },
                expression: "customOptionA"
              }
            }),
            _vm._v(" "),
            _c("b-form-select", {
              staticClass: "form-control",
              staticStyle: { color: "blue" },
              attrs: { options: _vm.filteredOptions("B") },
              scopedSlots: _vm._u([
                {
                  key: "first",
                  fn: function() {
                    return [
                      _c("b-form-select-option", { attrs: { value: null } }, [
                        _vm._v("Selecione a opção B")
                      ])
                    ]
                  },
                  proxy: true
                }
              ]),
              model: {
                value: _vm.customOptionB,
                callback: function($$v) {
                  _vm.customOptionB = $$v
                },
                expression: "customOptionB"
              }
            }),
            _vm._v(" "),
            _c("b-form-select", {
              staticClass: "form-control",
              staticStyle: { color: "purple" },
              attrs: { options: _vm.filteredOptions("C") },
              scopedSlots: _vm._u([
                {
                  key: "first",
                  fn: function() {
                    return [
                      _c("b-form-select-option", { attrs: { value: null } }, [
                        _vm._v("Selecione a opção C")
                      ])
                    ]
                  },
                  proxy: true
                }
              ]),
              model: {
                value: _vm.customOptionC,
                callback: function($$v) {
                  _vm.customOptionC = $$v
                },
                expression: "customOptionC"
              }
            }),
            _vm._v(" "),
            _c("SelectYear", {
              model: {
                value: _vm.referenceYear,
                callback: function($$v) {
                  _vm.referenceYear = $$v
                },
                expression: "referenceYear"
              }
            }),
            _vm._v(" "),
            _vm.customOptionA &&
            _vm.customOptionB &&
            _vm.customOptionC &&
            _vm.referenceYear
              ? _c("b-form-select", {
                  staticClass: "form-control mr-3",
                  attrs: { options: _vm.installationStatusOption },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "first",
                        fn: function() {
                          return [
                            _c(
                              "b-form-select-option",
                              { attrs: { value: null } },
                              [_vm._v("Selecione um status")]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    3578769603
                  ),
                  model: {
                    value: _vm.filter.status,
                    callback: function($$v) {
                      _vm.$set(_vm.filter, "status", $$v)
                    },
                    expression: "filter.status"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.customOptionA &&
            _vm.customOptionB &&
            _vm.customOptionC &&
            _vm.referenceYear
              ? _c("SelectBillingStatus", {
                  model: {
                    value: _vm.filter.billingStatus,
                    callback: function($$v) {
                      _vm.$set(_vm.filter, "billingStatus", $$v)
                    },
                    expression: "filter.billingStatus"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.customOptionA &&
            _vm.customOptionB &&
            _vm.customOptionC &&
            _vm.referenceYear
              ? _c("GenericSearchInput", {
                  model: {
                    value: _vm.filter.search,
                    callback: function($$v) {
                      _vm.$set(_vm.filter, "search", $$v)
                    },
                    expression: "filter.search"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "BaseButtonComponent",
              {
                attrs: {
                  variant: "primary-action",
                  disabled: !(
                    _vm.customOptionA &&
                    _vm.customOptionB &&
                    _vm.customOptionC &&
                    _vm.referenceYear
                  )
                },
                on: {
                  click: function($event) {
                    return _vm.getAll()
                  }
                }
              },
              [_vm._v("\n        Buscar\n      ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.isLoading ? _c("loading-list") : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && Object.entries(_vm.panoramaList).length !== 0
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-between flex-column h-100" },
            [
              _c(
                "Table",
                {
                  staticClass: "panorama-custom-table",
                  staticStyle: { "margin-top": "1rem" }
                },
                [
                  _c(
                    "TableHeader",
                    [
                      _c(
                        "TableRow",
                        _vm._l(_vm.monthList, function(month, index) {
                          return _c("TableHead", { key: `${month}_${index}` }, [
                            _vm._v(
                              "\n            " + _vm._s(month) + "\n          "
                            )
                          ])
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "TableBody",
                    _vm._l(Object.entries(_vm.panoramaList), function(
                      consumerBillItem,
                      index
                    ) {
                      return _c(
                        "TableRow",
                        { key: `${consumerBillItem}_${index}` },
                        [
                          _c("TableCell", [
                            _c("span", [_vm._v(_vm._s(consumerBillItem[0]))])
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  consumerBillItem[1].length
                                    ? _vm.getUserName(consumerBillItem[1])
                                    : ""
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  consumerBillItem[1].length
                                    ? _vm.getConsumerBillItemStatus(
                                        consumerBillItem[1]
                                      )
                                    : ""
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("PanoramaCustomTableCell", {
                                attrs: {
                                  consumerBillItem: consumerBillItem[1],
                                  monthIndex: _vm.monthsIndex.Janeiro,
                                  propertyNameA: _vm.propertyNameA,
                                  propertyNameB: _vm.propertyNameB,
                                  propertyNameC: _vm.propertyNameC
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("PanoramaCustomTableCell", {
                                attrs: {
                                  consumerBillItem: consumerBillItem[1],
                                  monthIndex: _vm.monthsIndex.Fevereiro,
                                  propertyNameA: _vm.propertyNameA,
                                  propertyNameB: _vm.propertyNameB,
                                  propertyNameC: _vm.propertyNameC
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("PanoramaCustomTableCell", {
                                attrs: {
                                  consumerBillItem: consumerBillItem[1],
                                  monthIndex: _vm.monthsIndex.Março,
                                  propertyNameA: _vm.propertyNameA,
                                  propertyNameB: _vm.propertyNameB,
                                  propertyNameC: _vm.propertyNameC
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("PanoramaCustomTableCell", {
                                attrs: {
                                  consumerBillItem: consumerBillItem[1],
                                  monthIndex: _vm.monthsIndex.Abril,
                                  propertyNameA: _vm.propertyNameA,
                                  propertyNameB: _vm.propertyNameB,
                                  propertyNameC: _vm.propertyNameC
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("PanoramaCustomTableCell", {
                                attrs: {
                                  consumerBillItem: consumerBillItem[1],
                                  monthIndex: _vm.monthsIndex.Maio,
                                  propertyNameA: _vm.propertyNameA,
                                  propertyNameB: _vm.propertyNameB,
                                  propertyNameC: _vm.propertyNameC
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("PanoramaCustomTableCell", {
                                attrs: {
                                  consumerBillItem: consumerBillItem[1],
                                  monthIndex: _vm.monthsIndex.Junho,
                                  propertyNameA: _vm.propertyNameA,
                                  propertyNameB: _vm.propertyNameB,
                                  propertyNameC: _vm.propertyNameC
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("PanoramaCustomTableCell", {
                                attrs: {
                                  consumerBillItem: consumerBillItem[1],
                                  monthIndex: _vm.monthsIndex.Julho,
                                  propertyNameA: _vm.propertyNameA,
                                  propertyNameB: _vm.propertyNameB,
                                  propertyNameC: _vm.propertyNameC
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("PanoramaCustomTableCell", {
                                attrs: {
                                  consumerBillItem: consumerBillItem[1],
                                  monthIndex: _vm.monthsIndex.Agosto,
                                  propertyNameA: _vm.propertyNameA,
                                  propertyNameB: _vm.propertyNameB,
                                  propertyNameC: _vm.propertyNameC
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("PanoramaCustomTableCell", {
                                attrs: {
                                  consumerBillItem: consumerBillItem[1],
                                  monthIndex: _vm.monthsIndex.Setembro,
                                  propertyNameA: _vm.propertyNameA,
                                  propertyNameB: _vm.propertyNameB,
                                  propertyNameC: _vm.propertyNameC
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("PanoramaCustomTableCell", {
                                attrs: {
                                  consumerBillItem: consumerBillItem[1],
                                  monthIndex: _vm.monthsIndex.Outubro,
                                  propertyNameA: _vm.propertyNameA,
                                  propertyNameB: _vm.propertyNameB,
                                  propertyNameC: _vm.propertyNameC
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("PanoramaCustomTableCell", {
                                attrs: {
                                  consumerBillItem: consumerBillItem[1],
                                  monthIndex: _vm.monthsIndex.Novembro,
                                  propertyNameA: _vm.propertyNameA,
                                  propertyNameB: _vm.propertyNameB,
                                  propertyNameC: _vm.propertyNameC
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("PanoramaCustomTableCell", {
                                attrs: {
                                  consumerBillItem: consumerBillItem[1],
                                  monthIndex: _vm.monthsIndex.Dezembro,
                                  propertyNameA: _vm.propertyNameA,
                                  propertyNameB: _vm.propertyNameB,
                                  propertyNameC: _vm.propertyNameC
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && Object.entries(_vm.panoramaList).length === 0
        ? _c("empty-list")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }